import { Bar } from './BaseCharts'
// import { db } from '@/firebase'
// const anaRef = db.ref('analytics')

export default {
  data() {
    return {
      backgroundColor: ['#5cbae6', '#b6d957', '#fac364', '#8cd3ff', '#d998cb', '#f2d249', '#93b9c6', '#ccc5a8', '#52bacc', '#dbdb46', '#98aafb'],
    }
  },
  props: {
    graphData: {
      jobArray: [],
      jobNumberArray: [],
      timestamp: new Date(),
    },
  },
  extends: Bar,
  watch: {
    graphData() {
      this.renderChart({ labels: this.graphData.jobArray, datasets: this.setChartData(this.graphData.jobArray, this.graphData.jobNumberArray) }, this.setChartOptions())
    },
  },
  methods: {
    setChartData: function (jobArray, jobNumberArray) {
      let includedGraph = []
      if (jobNumberArray !== undefined) {
        includedGraph.push({
          label: '',
          yAxisID: 'rating',
          backgroundColor: ['#5cbae6', '#b6d957', '#fac364', '#8cd3ff', '#d998cb', '#f2d249', '#93b9c6', '#ccc5a8', '#52bacc', '#dbdb46', '#98aafb'],
          borderColor: ['#5cbae6', '#b6d957', '#fac364', '#8cd3ff', '#d998cb', '#f2d249', '#93b9c6', '#ccc5a8', '#52bacc', '#dbdb46', '#98aafb'],
          fill: false,
          pointRadius: 6,
          borderWidth: 1,
          data: jobNumberArray,
          datalabels: {
            align: 'end',
            anchor: 'end',
          },
        })
      }
      return includedGraph
    },
    setChartOptions: function () {
      return {
        layout: {
          padding: {
            left: 0,
            right: 50,
            top: 0,
            bottom: 0,
          },
        },
        legend: {
          display: false,
        },
        responsive: true,
        maintainAspectRatio: false,
        FontFamily: 'sans-serif',
        animation: false,
        scales: {
          yAxes: [{
            id: 'rating',
            scaleLabel: {
              display: true,
              labelString: 'Rating',
            },
            ticks: {
              beginAtZero: true,
              steps: 1,
              stepValue: 1,
              max: 5,
            },
          // },
          // {
          //   id: 'quantity',
          //   position: 'right',
          //   scaleLabel: {
          //     display: true,
          //     labelString: 'Quantity'
          //   },
          //   ticks: {
          //     beginAtZero: true,
          //     steps: 1,
          //     stepValue: 1,
          //     max: 5
          //   }
          // }],
          }],
          xAxes: [{
            scaleLabel: {
              display: false,
              labelString: 'Date',
            },
          }],
        },
        plugins: {
          datalabels: {
            display: (context) => {
              // return context.dataset.data[context.dataIndex] !== 0
              return context.chart.isDatasetVisible(context.datasetIndex)
            },
            backgroundColor: function(context) {
              return context.dataset.backgroundColor
            },
            borderRadius: 6,
            color: 'white',
            font: {
              weight: 'bold',
            },
            formatter: Math.round,
          },
        },
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/methods/JobAnalyticsChart.js